import { render, staticRenderFns } from "./advertisingForm.vue?vue&type=template&id=538d9f01&scoped=true&"
import script from "./advertisingForm.vue?vue&type=script&lang=js&"
export * from "./advertisingForm.vue?vue&type=script&lang=js&"
import style0 from "./advertisingForm.vue?vue&type=style&index=0&id=538d9f01&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538d9f01",
  null
  
)

export default component.exports